<a href="mailto:{{ email }}"
  ><ng-container *ngIf="displayText">{{ displayText }}</ng-container
  ><ng-container *ngIf="!displayText">{{ email }}</ng-container></a
>
